import { useState } from 'react';
import { useQuery } from 'react-query';
import api from 'api';

import { isDeclarationWindowCurrentlyOpen } from '../utils';
import { DECLARATION_WINDOW_TYPES } from '../types';

export const useIsDeclarationWindowOpen = ({ userId }: { userId: string | number | undefined }) => {
  const [isDeclarationWindowOpen, setIsDeclarationWindowOpen] = useState(false);

  useQuery({
    queryKey: ['declaration_window', userId],
    queryFn: async () =>
      api.flexibleBenefitComponents.queries.getEffectiveSetting({
        setting_name: 'declaration_window_config',
        employee_id: userId?.toString() ?? '',
      }),
    onSuccess: (data) => {
      const settingData = data.payrollGetEffectiveSetting.data;
      const configValues = settingData?.map_value;
      if (!configValues) {
        setIsDeclarationWindowOpen(false);
        return;
      }

      const { active_key, values } = configValues;
      const activeKey = !!settingData?.override_applied
        ? DECLARATION_WINDOW_TYPES.CUSTOM_RANGE
        : active_key;
      const activeSetting = values?.[activeKey];
      const isOpen = isDeclarationWindowCurrentlyOpen(activeSetting, activeKey);

      setIsDeclarationWindowOpen(isOpen);
    },
    enabled: !!userId,
  });

  return {
    isDeclarationWindowOpen,
  };
};
